<template>
  <div>
    <liste-template>
      <template #header>
        <h1 class="title is-size-3">{{ $t('listeSuiviAchats.title') }}</h1>
        <breadcrumb :breadcrumb="breadcrumb"/>
      </template>
      <template #bar-left>
        <div class="column is-narrow">
          <selecteur-action
            :options="actions"
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="getAllItemsSelected().length > 0"
            @handleAction="handleAction">
          </selecteur-action>
        </div>
        <form @submit.prevent="recherche()"
          class="column is-narrow  pdr-0">
          <b-input :placeholder="$t('general.button.search')"
            type="search"
            icon="magnify"
            v-model="critereRecherche.auto">
          </b-input>
        </form>
        <div class='column is-narrow'>
          <button class="button" @click='setShowFiltre'>
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span @click="reinitialiserFiltre()"
            class="info-circle-right is-pulled-right is-cursor-pointer">
            <b-icon icon="close-circle" type="is-danger"></b-icon>
          </span>
        </div>
      </template>
      <template #bar-right>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </template>
      <template #content>
        <v-server-table
          url=""
          v-if="startArrayRendering"
          :columns="columns"
          :options="options"
          class="tableWithChildRow"
          :ref="referenceTable"
          @loaded="finLoading" @loading="debutLoading">
          <template #appendBody>
            <table-footer-totaux
              :columns="columns"
              :target="targetTotal"
              :items="items">
            </table-footer-totaux>
          </template>
          <template #afterTable>
            <table-items-in-view
              :perPage="resultPerPage"
              @input="$refs[referenceTable].setLimit($event)"/>
          </template>
          <template #selected="{ row }">
            <div class="has-text-centered">
              <b-checkbox v-model="row.selected"></b-checkbox>
            </div>
          </template>
          <template #code="{ row }">
            <router-link
              :to="{ name: 'c.achat.commandes', params: { id: row.id }}"
              :class="{'text-access-no-permission': !checkPermissions(perm.lecture)}"
              class="lien">
              {{ row.code }}
            </router-link>
          </template>
          <template #dateDevisCommande="{ row }">
            {{ func.formatDate(row.dateDevisCommande) }}
          </template>
          <template #fournisseur="{ row }">
            <router-link-blank
              v-for="(inter, index) in row.intervenants"
              :key="index"
              :to="getRouteToTiers(inter.tiers)"
              :message="inter.nomCommercial">
            </router-link-blank>
          </template>
          <template #etat="{ row }">
            {{ getEtatLibelle(row.etat) }}
          </template>
          <template #totalQuantite="{ row }">
            <div class="is-pulled-right">
              {{ row.totalQuantite }}
            </div>
          </template>
          <template #montantHt="{ row }">
            <div class="is-pulled-right">
              {{ func.formatDevise(row.montantHt) }}
            </div>
          </template>
          <template #facturer="{ row }">
            <b-tooltip
              :label="$t('listeSuiviAchats.facturerToolTipLabel')"
              :active="!canBeInvoiced(row)"
              position="is-left">
              <qd-button
                :disabled="!canBeInvoiced(row)"
                @click="handleAction(constantes.ACTION_MASSE_FACTURER, row)"
                class="button is-addOrEdit">
                {{ $t('listeSuiviAchats.actions.facturer') }}
              </qd-button>
            </b-tooltip>
          </template>
          <template #receptionner="{ row }">
            <b-tooltip
              :label="$t('listeSuiviAchats.rececptionnerToolTipLabel')"
              :active="!allLignesCommandeNonRapprochees(row)"
              position="is-left">
              <qd-button
                :disabled="!allLignesCommandeNonRapprochees(row)"
                @click="handleAction(constantes.ACTION_MASSE_RECEPTIONNER, row)"
                class="button is-addOrEdit">
                {{ $t('listeSuiviAchats.actions.receptionner') }}
              </qd-button>
            </b-tooltip>
          </template>
          <template #child_row="{ row }">
            <ligne-commande-child-row :data="row"/>
          </template>
        </v-server-table>
      </template>
      <template #filter>
        <div class="componentBrief" v-show="showFiltre">
          <filtre-liste-suivi-achats ref="filtreListe"
            @toggleFiltre="setShowFiltre"
            @recherche="makeRechercheFilter"/>
        </div>
      </template>
    </liste-template>
    <b-modal
      v-model="popUpPrevention"
      @close="closePopUpPrevention"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :mess-header="msgPopUpPrevention.header"
        :mess-description="msgPopUpPrevention.description"
        :messages-popup="messagesErreurPopUp"
        :is-error-popup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="closePopUpPrevention"
        @yes="actionYesPopUpPreventionAsync"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import listeTemplate from '@/components/general/template/listeTemplate';
import breadcrumb from '@/components/general/breadcrumb';
import { SUIVI_TACHES_INTERNES } from '@/configuration/achat/permissionsConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import tableItemsInView from '@/components/general/TableItemsInView';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_SUIVI_TACHES_INTERNES } from '@/configuration/general/referenceTableConf';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import selecteurAction from '@/components/general/selecteurAction';
import {
  ACTION_MASSE_FACTURER,
  ACTION_MASSE_RECEPTIONNER,
  LISTE_INCLUSIONS_SUIVI_TACHES_INTERNES,
} from '@/configuration/achat/suiviAchats/suiviAchatsConf';
import formatDate from '@/services/general/formatDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import { COMMANDE_ACHAT_FOURNISSEUR_ETAT } from '@/configuration/devisConf';
import { ETAT_NON_RAPPROCHE_TYPE } from '@/configuration/achat/bonReception/rapprochementConfig';
import filtreListeSuiviAchats from '@/components/achat/suiviAchats/filtreListeSuiviAchats';
import ligneCommandeChildRow from '@/components/achat/suiviAchats/ligneCommandeChildRow';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import { generateBonReceptionAll } from '@/api/bonReception';
import popUpPrevention from '@/components/general/popUpPrevention';
import { factureGeneration } from '@/api/factureAchatARapprocher';
import formatIsoDate from '@/services/general/formatIsoDate';
import validation from '@/services/achat/suiviAchats/validation';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const SuiviAchats = createNamespacedHelpers('suiviAchats');

export default {
  name: 'LSuiviTachesInternes',
  data() {
    return {
      perm: SUIVI_TACHES_INTERNES,
      unsubscribeValue: null,
      showFiltre: false,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_SUIVI_TACHES_INTERNES,
      func: { formatDate, formatDevise },
      constantes: {
        ACTION_MASSE_RECEPTIONNER,
        ACTION_MASSE_FACTURER,
      },
      msgPopUpPrevention: {
        header: '',
        description: '',
      },
      actionYesPopUpPrevention: null,
      messagesErreurPopUp: [],
      errorPopUp: false,
      popUpPrevention: false,
    };
  },
  components: {
    listeTemplate,
    breadcrumb,
    tableItemsInView,
    parametrageTable,
    selecteurAction,
    filtreListeSuiviAchats,
    ligneCommandeChildRow,
    routerLinkBlank,
    tableFooterTotaux,
    popUpPrevention,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...SuiviAchats.mapGetters({
      items: 'items',
      totalCount: 'total',
      critereRecherche: 'criteresRecherche',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeSuiviAchats.title'), route: '', isActive: true },
      ];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'sousType', 'module'];
      const nbCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    actions() {
      return [
        {
          action: ACTION_MASSE_FACTURER,
          translation: 'listeSuiviAchats.actions.facturer',
        },
        {
          action: ACTION_MASSE_RECEPTIONNER,
          translation: 'listeSuiviAchats.actions.receptionner',
        },
      ];
    },
    columnsData() {
      return [
        { name: 'selected', noTranslate: true },
        { name: 'code', sortable: true },
        { name: 'dateDevisCommande', sortable: true },
        { name: 'fournisseur', sortable: false },
        { name: 'etat', sortable: true },
        { name: 'totalQuantite', sortable: true },
        { name: 'montantHt', sortable: true },
        { name: 'receptionner' },
        { name: 'facturer' },
      ];
    },
    columns() {
      return this.columnsData.map((column) => column.name);
    },
    allItemsSelected() {
      return this.getAllItemsSelected().length === this.items.length;
    },
    iconSelectTotal() {
      if (this.allItemsSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const selectedFunc = (h) => {
        return h(
          'a', {
            attrs: { class: 'pointer' },
            on: {
              click: () => { this.selectAll(); },
            },
          },
          [h('b-icon', { attrs: { icon: this.iconSelectTotal } })],
        );
      };
      const headings = this.columnsData.reduce((acc, column) => {
        const field = column.trad || column.name;
        const key = `listeSuiviAchats.tabs.${field}`;
        if (column.name === 'selected') {
          acc[column.name] = selectedFunc;
        } else {
          acc[column.name] = this.$te(key) ? this.$t(key) : '';
        }
        return acc;
      }, {});
      return {
        sortIcon: SORT_ICON,
        headings,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        columnsClasses: {
          selected: 'colonneSelected',
        },
        requestFunction: ((data) => {
          data.inclusion = LISTE_INCLUSIONS_SUIVI_TACHES_INTERNES.map(el => el.value);
          data.query = cloneDeep(this.critereRecherche);
          data.query.tiersId = tagInputToArray(data.query.tiersId, 'id');
          data.query.produitsIds = tagInputToArray(data.query.produitsIds, 'id');
          data.query.etat = tagInputToArray(data.query.etat, 'code');
          data.query.societeId = this.societeActiveId;
          return this.actionLoadTachesInternes(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        sortable: this.columnsData.filter((c) => c.sortable).map((c) => c.name),
      };
    },
    targetTotal() {
      return ['montantHt'];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...SuiviAchats.mapActions({
      actionLoadTachesInternes: 'loadItems',
    }),
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    reinitialiserFiltre() {
      this.$refs.filtreListe.initializeFiltre();
      this.$refs.filtreListe.viderCritere();
      this.$refs.filtreListe.appliquerCritere();
      this.showFiltre = false;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListe.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    getAllItemsSelected() {
      return this.items.filter((el) => { return el.selected; });
    },
    selectAll() {
      const select = !this.allItemsSelected;
      this.items.forEach((el) => { el.selected = select; });
    },
    getRouteToTiers(tiers) {
      const routeName = tiers.type === TIERS_TYPE_FOURNISSEUR
        ? 'c.achat.fournisseurs'
        : 'c.bodac.clients/contacts-client';
      return { name: routeName, params: { id: tiers.id } };
    },
    getEtatLibelle(etat) {
      const find = COMMANDE_ACHAT_FOURNISSEUR_ETAT.find((el) => el.code === etat);
      return find ? this.$t(find.libelle) : '';
    },
    allLignesCommandeNonRapprochees(item) {
      return item.lignesCommande
        .every((ligne) => ligne.etatRapprochement === ETAT_NON_RAPPROCHE_TYPE);
    },
    async generateBonReception(id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = id ? [id] : this.getAllItemsSelected().map((el) => el.id);
        await generateBonReceptionAll({ ids });
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
    },
    openPopUpPrevention({ header, description, actionYes }) {
      this.msgPopUpPrevention.header = header;
      this.msgPopUpPrevention.description = description;
      this.actionYesPopUpPrevention = actionYes;
      this.popUpPrevention = true;
    },
    closePopUpPrevention() {
      this.msgPopUpPrevention.header = '';
      this.msgPopUpPrevention.description = '';
      this.actionYesPopUpPrevention = null;
      this.popUpPrevention = false;
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
    },
    async actionYesPopUpPreventionAsync() {
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
      this.debutLoading();
      try {
        await this.actionYesPopUpPrevention();
        this.closePopUpPrevention();
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      } finally {
        this.finLoading();
      }
    },
    canBeInvoiced(item) {
      return item.echeanciers.some((echeancier) => {
        return echeancier.echeancierLignes.some((ligne) => {
          return ligne.factureId === null && !ligne.facturationFaite;
        });
      });
    },
    initialiseListeEcheancePayeurs(commandes) {
      const echeancePayeurLigne = [];
      commandes.flatMap(commande => commande.echeanciers).forEach(echeancier => {
        echeancier.echeancierLignes
          .filter(ligneEcheance => ligneEcheance.factureId === null
            && !ligneEcheance.facturationFaite)
          .forEach(ligne => {
            const echeance = {
              id: ligne.id,
            };
            echeancePayeurLigne.push(echeance);
          });
      });
      return echeancePayeurLigne.sort(this.compareEcheance);
    },
    async generationFacture(commandes) {
      const echeances = this.initialiseListeEcheancePayeurs(commandes);
      await factureGeneration({
        listeEcheancierLigneId: echeances.map((ech) => ech.id),
        dateFacturation: formatIsoDate(new Date()),
        calculeEnQuantite: true,
        genererFactureZero: true,
        enregistrerFactures: false,
        estARapprocher: true,
      });
    },
    handleAction(action, commande) {
      switch (action) {
        case ACTION_MASSE_FACTURER:
        {
          const commandes = commande ? [commande] : this.getAllItemsSelected();
          this.openPopUpPrevention({
            header: this.$t('listeSuiviAchats.facturerAllPopUpHeader'),
            description: this.$t('listeSuiviAchats.facturerAllPopUpDescription'),
            actionYes: () => this.generationFacture(commandes),
          });
          break;
        }
        case ACTION_MASSE_RECEPTIONNER:
        {
          const ids = commande ? [commande.id] : this.getAllItemsSelected().map(b => b.id);
          this.openPopUpPrevention({
            header: this.$t('listeSuiviAchats.receptionnerAllPopUpHeader'),
            description: this.$t('listeSuiviAchats.receptionnerAllPopUpDescription'),
            actionYes: () => generateBonReceptionAll({ ids }),
          });
          break;
        }
        default:
          messageErreur(this.$i18n, this.$i18n.t('general.noActionSelect'));
          break;
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    this.debutLoading();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageAchat.suiviAchats.liste'));
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    } finally {
      this.finLoading();
    }
  },
};
</script>
